import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { authClient } from "@/lib/auth";

export function OrgSettingsPage() {
  const [linkError, setLinkError] = useState<string | null>(null);

  async function linkGoogle() {
    setLinkError(null);
    try {
      // Attaches a Google identity to the CURRENTLY signed-in account (as
      // opposed to signIn.social, used on Login/Signup, which creates a
      // fresh session). Same redirect-based OAuth dance — lands back here
      // via the same getSession()-recovery fallback lib/ws.ts's connect()
      // already relies on for the sign-in path.
      await authClient.linkSocial({
        provider: "google",
        callbackURL: window.location.pathname,
      });
    } catch (err) {
      setLinkError(
        err instanceof Error ? err.message : "Could not start Google linking",
      );
    }
  }

  return (
    <div className="max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-sm text-muted-foreground">Manage your account.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Linked accounts</CardTitle>
          <CardDescription>
            Sign in with a social account instead of (or in addition to) your
            password.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button variant="outline" onClick={linkGoogle} type="button">
            Link Google account
          </Button>
          {linkError && (
            <Alert variant="destructive">
              <AlertDescription>{linkError}</AlertDescription>
            </Alert>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
